// @flow

import { useSelector, useDispatch } from "react-redux";
import React, { useEffect } from "react";
import * as R from "ramda";
import { Box, Table } from "@chakra-ui/react";

import SingleSelect from "src/components/Unifize/Select/SingleSelect";
import {
  getCurrentChecklistBuilder,
  getChecklistFieldPosition,
  getFormChecklistFields,
  getAllForms,
} from "src/reducers";
import { fetchForm } from "src/actions/forms";
import FormField from "./FormField";
import Builder from "./Builder";

type Props = {
  setLocalSettings: Function,
  selectedFormField: ?string,
  selectFormField: Function,
  selectedFormId: ?string,
  setSelectedFormId: Function,
};

const FormConditions = ({
  setLocalSettings,
  selectedFormId,
  setSelectedFormId,
  selectedFormField,
  selectFormField,
}: Props) => {
  const dispatch = useDispatch();

  const allForms = useSelector(({ app }) => getAllForms(app));
  const currentFields = useSelector(
    ({ app }) => getCurrentChecklistBuilder(app).fields,
  );
  const checklistFieldPosition = useSelector(({ app }) =>
    getChecklistFieldPosition(app),
  );

  // Field data of the form field
  const currentFormField = currentFields[checklistFieldPosition];
  const currentFormFieldSettings = currentFormField?.settings || {};

  const currentFieldFormIds = currentFormFieldSettings.selectedForms || [];
  const formattedFieldFormIds = currentFieldFormIds.map((formId) => ({
    id: formId,
    value: allForms[formId]?.title ?? "",
  }));
  const selectedFormFields = useSelector(({ app }) =>
    getFormChecklistFields(app, selectedFormId || ""),
  );

  useEffect(() => {
    if (R.isEmpty(selectedFormFields) && selectedFormId) {
      dispatch(fetchForm(Number(selectedFormId)));
    }
  }, [selectedFormId]);

  return selectedFormField && selectedFormId ? (
    <Builder
      selectedFormId={Number(selectedFormId)}
      selectedFormField={Number(selectedFormField)}
      selectFormField={selectFormField}
      setLocalSettings={setLocalSettings}
    />
  ) : (
    <Box w={64}>
      <SingleSelect
        selected={selectedFormId ?? ""}
        placeholder="Select a form to add conditions"
        data={formattedFieldFormIds}
        keys={["id", "value"]}
        onChange={(e) => {
          setSelectedFormId(e);
        }}
      />
      <Table variant="unstyled" size="sm">
        {selectedFormFields
          ? selectedFormFields.map((field, index) => (
              <FormField
                key={field}
                fieldId={field}
                seqNo={index + 1}
                selectFormField={selectFormField}
              />
            ))
          : null}
      </Table>
    </Box>
  );
};

export default FormConditions;
